import React from 'react';
import { Button } from '@moda/om';
import FavoriteFilledIcon from '@moda/icons/favorite-filled-16';
import FavoriteOutlineIcon from '@moda/icons/favorite-outline-16';
import classNames from 'classnames';
import { UseFavoritesProps } from '../useFavorites';
import { FavoriteConfirmRemove } from '../FavoriteConfirmRemove';
import { useFavorite } from '../useFavorite';

export type FavoriteButtonProps = UseFavoritesProps & { className?: string };

export const FavoriteButton: React.FC<FavoriteButtonProps> = ({ variant, className }) => {
  const { label, onClick, isFavorited, showConfirmRemove, onCloseConfirm } = useFavorite({
    variant
  });

  return (
    <>
      <Button
        aria-label={label}
        className={classNames('FavoriteButton', className)}
        data-testid="favorite-button"
        onClick={onClick}
        secondary
      >
        {isFavorited ? <FavoriteFilledIcon /> : <FavoriteOutlineIcon />}

        {label}
      </Button>

      {showConfirmRemove && <FavoriteConfirmRemove onConfirm={onClick} onClose={onCloseConfirm} />}
    </>
  );
};
